export default "__VITE_ASSET__BaLjBDeo__"